import { PaginatedListResponse } from "@/domain/dto/BaseDataResponse"
import { ListCancellationReasonsQueryParamsDTO } from "@/domain/dto/ListCancellationReasonsQueryParamsDTO"
import { ListPrescriptionFeedbackQueryParamsDTO } from "@/domain/dto/ListPrescriptionFeedbackQueryParamsDTO"
import { CancellationReason } from "@/domain/entities/CancellationReason"
import { PrescriptionFeedback } from "@/domain/entities/PrescriptionFeedback"
import { UserSubscriptionTransaction } from "@/domain/entities/UserSubscriptionTransaction"
import { IUserRepository } from "@/domain/repositories/IUserRepository"
import { IUserRemoteDataSource } from "../datasources/interfaces/remote/IUserRemoteDataSource"
import CancellationReasonMappers from "../mappers/CancellationReasonMappers"
import PrescriptionFeedbackMappers from "../mappers/PrescriptionFeedbackMappers"
import ResponseDataMappers from "../mappers/ResponseDataMappers"
import UserSubscriptionHistoryDataMappers from "../mappers/UserSubscriptionHistoryDataMappers"

export class UserRepository implements IUserRepository {
    dataSource: IUserRemoteDataSource
    constructor(dataSource: IUserRemoteDataSource) {
        this.dataSource = dataSource
    }

    async listSubscriptionHistory(userId: string): Promise<UserSubscriptionTransaction[]> {
        const response = await this.dataSource.listSubscriptionHistory(userId)
        console.log(response)
        return UserSubscriptionHistoryDataMappers.toTransactionList(response.data)
    }

    async listPrescriptionFeedback(params: ListPrescriptionFeedbackQueryParamsDTO): Promise<PaginatedListResponse<PrescriptionFeedback>> {
        const response = await this.dataSource.listPrescriptionFeedback(params)
        return ResponseDataMappers.toPaginatedListResponse(response, response.data.map(PrescriptionFeedbackMappers.toEntity))
    }

    async listCancellationReasons(params: ListCancellationReasonsQueryParamsDTO): Promise<PaginatedListResponse<CancellationReason>> {
        const response = await this.dataSource.listCancellationReasons(params)
        return ResponseDataMappers.toPaginatedListResponse(response, response.data.map(CancellationReasonMappers.toEntity))

    }
}
